import React, { useRef, useState } from 'react'

import { Flex } from '@stackhouse/styled-elements'

import Modal from '@stackhouse/dashboard-components/Modal'
import Button from '@stackhouse/dashboard-components/Button'
import { withDashboardContext } from '@stackhouse/dashboard-components/Dashboard'

import Form from '../components/ResponsiveForm'


const exportFields = {
    processType: {
        type: 'radio',
        group: 0,
        horizontal: true,
        id: 'processType',
        label: 'Process Type',
        value: 'realtime',
        options: [
            {
                value: 'realtime',
                label: 'Real time'
            },
            {
                value: 'batch',
                label: 'Batch'
            }
        ],
        disabled: true,
    },
    compressionType: {
        type: 'radio',
        group: 1,
        horizontal: true,
        id: 'compressionType',
        label: 'Compression',
        value: 'unzipped',
        options: [
            {
                value: 'unzipped',
                label: 'Unzipped'
            },
            {
                value: 'zipped',
                label: 'Zipped'
            }
        ],
    },
    convertToPdf: {
        type: 'checkboxbool',
        group: 2,
        id: 'convertToPdf',
        label: 'Convert to PDF'
    },
}


const ExportModal = withDashboardContext(({ close, endpoint, allowPDFConversion, requestData = {}, client, withLoader }) => {

    const formRef = useRef(null)
    const [fields] = useState({ ...exportFields, ...!allowPDFConversion ? { convertToPdf: null } : {} })

    const save = () => {

        const exportData = formRef.current.getValue()

        const data = {
            exportConfig: {
                realTimeExport: exportData.processType == 'realtime',
                zipResult: exportData.compressionType == 'zipped',
                convertToPdf: exportData.convertToPdf
            },
            ...requestData
        }

        return withLoader(done => {
            return client.post(endpoint, data, { responseType: 'blob' }).then(response => {
                const disposition = response.headers['content-disposition']
                const filenameRegex = / ?filename=([^;]+)(;|$)/i
                const filenameRegexMatches = disposition.match(filenameRegex)
                const filename = (filenameRegexMatches != null && filenameRegexMatches.length >= 1 && filenameRegexMatches[1] != null && filenameRegexMatches[1] != '')
                    ? filenameRegexMatches[1] : 'file'
                const type = response.headers['content-type']
                const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
                const link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `${filename}.${data.exportConfig.zipResult ? 'zip' : data.exportConfig.convertToPdf ? 'pdf' : 'xlsx'}`
                link.click()
            }).then(done).catch(done).then(close)
        })
    }

    return (
        <Flex column justifyCenter p={'1em'} backgroundColor={'white'} borderRadius={10}>
            <Flex column>
                <Form ref={formRef} fields={fields} />
            </Flex>
            <Flex row alignCenter justifyEvenly p={10}>
                <Button flex={1} outline title={'Cancel'} onClick={close} />
                <Button flex={1} ml={'1em'} title={'Export'} onClick={save} />
            </Flex>
        </Flex>
    )
}, ({ client, withLoader }) => ({ client, withLoader }))


export default ({ endpoint, allowPDFConversion, requestData = {} }) => {

    return Modal.show(
        ({ close }) => (
            <ExportModal close={close} endpoint={endpoint} allowPDFConversion={allowPDFConversion} requestData={requestData} />
        ),
        { target: 'content', animation: 'zoom' }
    )
}